<template>
    <div class="box-white-wrapper">
        <div class="do-now">
            <div class="icon"><img src="@/assets/images/no-data.png"/> </div>
            <div class="info">
                <div class="disclaimer">{{message}}</div>
                <vs-button color="primary" to="/pre-alert" type="border" icon="library_add" v-if="showButton">¡PreAlertar Ahora!</vs-button>
            </div>
        </div> 
    </div>
</template>
<script>
export default {
  name: 'DisplayInformation',
  props:{
    message: { type: String, required: true },
    showButton: { type: Boolean, required: false },
  },
  data (){
    return {
      Roles: []
    }
  }
}
</script>
